import React, { Component } from "react";
import Renderloiassessment from "./self-assessment";
import { SIDE_NAV_ITEMS, sliderData } from "../../api-constant";
import NewNavBar from "../NavBar/Navbar";
import Sidebar from "../Sidebar/sidebar";
import ResponsiveSidebar from "../Sidebar/Responsive/SideBar";
import axios from "axios";
import addAccessTokenToUrl from "../../Utils/Axios/addTokenToUrl";
import { withRouter } from "react-router";
import Navbar from "../../../_components/common/Navbar";

export class Renderselfassessment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSideNav: SIDE_NAV_ITEMS[0].id,
      sidebarOpen: false,
      isModalOpen: false,
      showDots: true,
      enableNotification: false,
      userAssessmentDetails: [],
      instrument_id: "",
      user_id: "",
      participant__id: "",
      instrumentMultiRater: "",
      organisation: "",
      seller: "",
      assessmentType: "",
      collapseID: null,
      isPopOverOpenAssessmentId: false
    };
  }
  /* load the popover after 500 miliseconds of page render*/
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isModalOpen: true,
      });
    }, 500);
    const instrument = this.props.match.params.instrument_id;
    const user = this.props.match.params.id;
    const participant = this.props.match.params.participant__id;
    const multiRater = this.props.match.params.instrument__is_multi_rater;
    const userOrg = this.props.match.params.organisation;
    const userSeller = this.props.match.params.seller;
    const assessmentCompletedCount = this.props.match.params
      .assessmentCompletedCount;
    const assessmentType = this.props.match.params.assessmentType;
    this.setState({
      instrument_id: instrument,
      user_id: user,
      participant__id: participant,
      instrumentMultiRater: multiRater,
      organisation: userOrg,
      seller: userSeller,
      completedCount: assessmentCompletedCount,
      assessmentType: assessmentType,
      invitationDetails: null,
      slideIndex: "",
    });
    /* handle api calls */
    axios
      .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
      .then((response) => {
        const invitationDetails = response.data.my_inivation.find((i) => {
          return i.user_assessment__id == user;
        });
        this.setState({
          userAssessmentDetails: response.data.user_assessments,
          invitationDetails,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleSlideChange = (slideIndex) => {
    if (slideIndex === 3) {
      this.setState({
        showDots: false,
      });
    }
    this.setState({
      slideIndex,
    });
  };

  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };
  handleCloseNotification = () => {
    this.setState({
      enableNotification: false
    })
  }

  toggleCollapse = (collapseID) => {


    if (this.state.collapseID === collapseID) {
      this.setState({
        collapseID: null,
      });
    } else {
      this.setState({
        collapseID: collapseID,
      });
    }
  };

  handleAssessmentPopOver = (assessmentId) => {
    this.setState({
      isPopOverOpenAssessmentId: assessmentId,
      overlayIsVisible: true,
    });
  };

  handleClosePopOver = () => {
    this.setState({
      isPopOverOpenAssessmentId: false,
      overlayIsVisible: false,
    });
  };

  render() {
    const userType = localStorage.getItem("usertype");
    return (
      <div>
        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? (
          <Navbar />
        ) : (
          <NewNavBar
            enableNotification={this.state.enableNotification}
            handleNotification={this.handleNotification}
            handleCloseNotification={this.handleCloseNotification}
          />
        )}
        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <Sidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
          />
        ) : null}

        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? null : (
          <ResponsiveSidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
            sidebarOpen={this.state.sidebarOpen}
            onSetSidebarOpen={this.onSetSidebarOpen}
          />
        )}
        {this.state.assessmentType == "invitations" ? (
          <Renderloiassessment
            userAssessmentDetails={this.state.userAssessmentDetails}
            isModalOpen={this.state.isModalOpen}
            overlayIsVisible={this.state.overlayIsVisible}
            sliderData={sliderData}
            showDots={this.state.showDots}
            handleSlideChange={this.handleSlideChange}
            instrument_id={this.state.instrument_id}
            user_id={this.state.user_id}
            participant__id={this.state.participant__id}
            instrumentMultiRater={this.state.instrumentMultiRater}
            organisation={this.state.organisation}
            seller={this.state.seller}
            completedCount={this.state.completedCount}
            assessmentType={this.state.assessmentType}
            invitationDetails={this.state.invitationDetails}
            slideIndex={this.state.slideIndex}
            toggleCollapse={this.toggleCollapse}
            collapseID={this.state.collapseID}
            handleAssessmentPopOver={this.handleAssessmentPopOver}
            handleClosePopOver={this.handleClosePopOver}
            isPopOverOpenAssessmentId={this.state.isPopOverOpenAssessmentId}
            startLink={`/new/app/questionnaire/${this.state.instrument_id}/${this.state.user_id}/${this.state.organisation}/${this.state.seller}/${this.state.participant__id}/${this.state.instrumentMultiRater}/${this.state.completedCount}/invitations`}
          />
        ) : (
          <Renderloiassessment
            userAssessmentDetails={this.state.userAssessmentDetails}
            isModalOpen={this.state.isModalOpen}
            overlayIsVisible={this.state.overlayIsVisible}
            sliderData={sliderData}
            showDots={this.state.showDots}
            handleSlideChange={this.handleSlideChange}
            instrument_id={this.state.instrument_id}
            user_id={this.state.user_id}
            participant__id={this.state.participant__id}
            instrumentMultiRater={this.state.instrumentMultiRater}
            organisation={this.state.organisation}
            seller={this.state.seller}
            completedCount={this.state.completedCount}
            assessmentType={this.state.assessmentType}
            invitationDetails={this.state.invitationDetails}
            toggleCollapse={this.toggleCollapse}
            collapseID={this.state.collapseID}
            handleAssessmentPopOver={this.handleAssessmentPopOver}
            handleClosePopOver={this.handleClosePopOver}
            isPopOverOpenAssessmentId={this.state.isPopOverOpenAssessmentId}
            startLink={`/new/app/questionnaire/${this.state.instrument_id}/${this.state.user_id}/${this.state.organisation}/${this.state.seller}/${this.state.participant__id}/${this.state.instrumentMultiRater}/${this.state.completedCount}/assessment`}
          />
        )}
      </div>
    );
  }
}

export default withRouter(Renderselfassessment);



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/index.jsx